<div
  class="container"
  [class.small]="small()">
  <div
    class="top"
    [ngStyle]="{ 'background-image': 'url(' + card?.backgroundUrl + ')' }">
    <h4 [innerHTML]="card?.headline"></h4>
    @if (card?.icon) {
      <div class="icon-wrapper">
        <div
          class="icon"
          [ngStyle]="{ 'background-image': 'url(' + iconUrl + ')' }"></div>
      </div>
    }
  </div>
  <div class="bottom">
    <p [innerHTML]="card?.text"></p>
    @if (card?.button) {
      <coin-v2-button
        type="secondary"
        icon="chevron_right"
        iconPos="right"
        [text]="card.button?.name"
        (click)="onButtonClick(card.button)"></coin-v2-button>
    }
  </div>
</div>
